import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ReactNode } from "react";

const SectionTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h2,
  color: theme.palette.common.black,
  [theme.breakpoints.down("sm")]: {
    fontSize: "36px",
  },
}));

const GreenText = styled("span")({
  background: "var(--green-accent)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
});


interface SectionHeadingProps {
  greenText?: string;
  children: ReactNode;
  maxWidth?: string;
}

export default function SectionHeading({
  greenText,
  children,
  maxWidth,
}: SectionHeadingProps) {
  return (
    <Box sx={{ maxWidth }}>
      <SectionTitle>
        {greenText && <GreenText>{greenText}</GreenText>}
        {greenText && " "}
        {children}
      </SectionTitle>
    </Box>
  );
}

export { GreenText };
